export default {
  // eslint-disable-next-line no-unused-vars
  addFlash: (context, payload) => {
    context.commit('clearFlashes');
    context.commit('addFlash', payload);
  },
};
